import { storyblokDataAttributes } from "@commerce-frontend/storyblok-preview/component";
import { graphql } from "@commerce-frontend/types";
import type { ResultOf } from "@graphql-typed-document-node/core";
import type { HTMLAttributes } from "react";
import { AssetImage } from "~/components/AssetImage/AssetImage";

export const ImageFragment = graphql(/* GraphQL */ `
	fragment ImageFragment on Image {
		__typename
		id
		image {
			...ImageAsset
		}
		aspectRatio
	}
`);

export type ImageBlockProps = {
	data: ResultOf<typeof ImageFragment>;
} & HTMLAttributes<HTMLDivElement>;

export const Image = ({ className, data }: ImageBlockProps) => {
	return (
		<div className={className} {...storyblokDataAttributes(data)}>
			<AssetImage
				data={data.image}
				aspectRatio={data.aspectRatio}
				style={{ width: "100%", height: "auto" }}
			/>
		</div>
	);
};
